import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useNamespacedTranslation } from '../../../../../../../hooks/useNamespacedTranslation';
import { HourHint } from '../../../../Projects/ProjectsTimesheets/HourHint';

type Props = {
  className?: string;
  showCostCenterLabel: boolean;
  showTimeEntryLabel: boolean;
  i18prefix: string;
};

const DayTimeInputLabels: React.FC<Props> = ({
  className,
  showCostCenterLabel,
  showTimeEntryLabel,
  i18prefix,
}) => {
  const t = useNamespacedTranslation(i18prefix);

  return (
    <Row className={className}>
      {showTimeEntryLabel && (
        <Col lg={2} xs={3}>
          <Form.Label className="mb-0">
            {t('timeEntries.form.timeEntryLabel')}
          </Form.Label>
        </Col>
      )}
      <Col lg={showTimeEntryLabel ? 2 : 3} xs={showTimeEntryLabel ? 4 : 4}>
        <Form.Label className="mb-0">
          {t('timeEntries.form.projectsLabel')}
        </Form.Label>
      </Col>
      <Col lg={2} xs={2}>
        <Form.Label className="mb-0">
          {t('timeEntries.form.hoursLabel')}
        </Form.Label>
      </Col>
      <Col lg={showTimeEntryLabel ? 3 : 4} xs={showTimeEntryLabel ? 5 : 6}>
        <Form.Label className="mb-0">
          {t('timeEntries.form.notesLabel')}
          <HourHint
            className="ps-1"
            text={t('timeEntries.form.notesPlaceholder')}
          />
        </Form.Label>
      </Col>
      {showCostCenterLabel && (
        <Col lg={2} xs={3}>
          <Form.Label className="mb-0">
            {t('timeEntries.form.costCenter')}
          </Form.Label>
        </Col>
      )}
    </Row>
  );
};

export default DayTimeInputLabels;
